<template>
    <div class='cusLayer on addCart' id='simple'>
        <div v-if='menu' class='cusCnt'>
            <div class='in'>
                <div class='tit'>
                    <MenuName :menu='menu'>
                        <strong>{{menu.name}}</strong>
                    </MenuName>
                </div>
                <dd class='total'>
                    <div class='qty'>
                        <div class='intRange type1'>
                            <button
                                type='button'
                                class='btn minus'
                                :class='{disabled: count === 1}'
                                @click='subCount'>
                                minus
                            </button>
                            <input v-model='count' class='input' readonly/>
                            <button
                                type='button'
                                class='btn plus'
                                @click='addCount'>
                                plus
                            </button>
                        </div>
                    </div>
                    <div class='sum'>
                        <strong>{{formatComma(count * menu.price)}}</strong><span>원</span>
                    </div>
                </dd>
            </div>
        </div>
        <div class='cusBtm btn2'>
            <button type='button' class='btn' data-action='close' @click='addCart'>카트담기</button>
            <button type='button' class='btn' data-action='close' @click='order'>바로결제</button>
        </div>
        <button class='btnCloseModal btnClose' data-action='close' @click='onClickCloseBtn'>닫기</button>
    </div>
</template>
<script type='js'>
import MenuName from '@/components/Common/MenuName.vue'
import { SIMPLE_MENU_DETAIL } from '@/utils/EndPoint'
import { ADD_CART_ITEM, SET_CART_TYPE } from '@/store/_actions/actionTypes'
import { addCart } from '@/utils/Methods'
import CloneDeep from 'lodash'
import { THROW_ORDER } from '@/router'
export default {
  name: SIMPLE_MENU_DETAIL,
  components: { MenuName },
  data () {
    return {
      count: 1
    }
  },
  computed: {
    // 현재 store Code
    currentStoreCode () { return this.$store.getters.currentStoreCode },
    cartMenuNo () { return this.$store.getters.cartMenuNo }, // 카트에 담겨있는 상품의 개수
    menu () { return this.$store.getters.currentMenu },
    simpleMenuChangedFlag () { return this.$store.getters.simpleMenuChangedFlag }, // 상품 변경 flag
    categoryCode () { return this.$store.getters.currentCategoryCode }
  },
  watch: {
    simpleMenuChangedFlag () {
      this.count = 1
    }
  },
  beforeDestroy () {
    this.removePopUp()
  },
  methods: {
    subCount () { if (this.count > 1) this.count-- },
    addCount () { this.count++ },
    getMenu () {
      const menu = CloneDeep.cloneDeep(this.menu)
      menu.count = this.count // 선택한 상품 개수
      menu.originPrice = this.menu.price // 상품의 기본 가격
      menu.storeCode = this.currentStoreCode // current store code
      menu.sale = true // 상품 주문 가능
      const menuKeyCode = menu.code
      return { menu: menu, key: menuKeyCode }
    },
    addCart () {
      // 카트에 상품 추가 후, popup 닫기
      this.$store.dispatch(ADD_CART_ITEM, this.getMenu())
        .then(() => {
          this.onClickCloseBtn()
          this.showAddCartAlert(() => { console.log('empty function') })
        })
    },
    order () { // 바로 결제
      // 바로결제일 경우 getMenu의 parameter->true로 전달
      const menu = this.getMenu()
      if (this.cartMenuNo > 0) { // 카트에 상품이 있는 경우
        this.$store.dispatch(SET_CART_TYPE, false).then(() => {
          this.onClickCloseBtn()
          this.$emit('setExtraMenu', menu)
        })
      } else {
        // 카트에 상품이 없는 경우에는 주문서 화면으로 이동
        const cart = {}
        addCart(cart, menu)
        THROW_ORDER(cart, menu.menu.originPrice * menu.menu.count)
      }
    },
    onClickCloseBtn () {
      this.removePopUp()
    }
  }
}
</script>
